<template>
    <div class="search-tab" :class="{'search-tab--active': active}" :data-testid="`search-panel-tab--${value}`" @click="$emit('click')">
        <VJoyIcon v-if="icon" class="search-tab__icon" :name="icon" color="neutral" />
        <div v-if="label" :class="{'search-tab__label': true, 'search-tab__label--is-ai-search': value === 'ai'}">
            {{ label }}
            <span class="search-tab__label-bold" aria-hidden="true">{{ label }}</span>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {VJoyIcon} from '@maltjoy/core-vue';

    defineProps<{
        value: string;
        label?: string;
        icon?: typeof VJoyIcon.props;
        active?: boolean;
    }>();

    defineEmits<{click: []}>();
</script>

<style lang="scss" scoped>
    @use '@malt/joy-entrypoint/src/sass/base/2_mixins/media-queries/media-queries' as mq;

    .search-tab {
        --inactive-bg-color: var(--joy-color-neutral-20);

        position: relative;
        display: flex;
        gap: var(--joy-core-spacing-2);
        align-items: center;
        padding: 0 var(--joy-core-spacing-4);
        height: 37px;
        transform: translate3d(0, 1px, 0);
        border-radius: var(--joy-core-radius-3) var(--joy-core-radius-3) 0 0;
        border: 1px solid var(--joy-color-neutral-30);
        border-bottom-color: var(--joy-color-neutral-0);
        cursor: pointer;
        font-size: var(--joy-font-size-primary-200);
        background-color: var(--inactive-bg-color);
        color: var(--joy-color-neutral-70);
        user-select: none;

        &__label {
            position: relative;
            display: none;
            white-space: nowrap;

            &--is-ai-search {
                display: block;
            }

            &-bold {
                position: absolute;
                background-color: var(--inactive-bg-color);
                top: 0;
                left: 50%;
                transform: translateX(-50%);
                text-align: center;
                font-weight: var(--joy-font-weight-bold);
                white-space: nowrap;
                opacity: 0;
                pointer-events: none;
                letter-spacing: var(--joy-font-letter-spacing-tight);
                transition: all var(--joy-transition-duration-short) var(--joy-transition-timing-function);
            }
        }

        /* ACTIVE */
        &--active {
            z-index: 1;

            .search-tab__label {
                display: flex;
            }
        }

        &--active,
        &:hover {
            background-color: var(--joy-color-background-default);

            .search-tab__label-bold {
                background-color: var(--joy-color-background-default);
                opacity: 1;
            }

            .joy-icon {
                color: var(--joy-color-neutral-70);
            }
        }

        /* TRANSITION */
        &,
        .joy-icon,
        &__tag,
        &__label-bold {
            transition: all var(--joy-transition-duration-short) var(--joy-transition-timing-function);
        }

        /* RESPONSIVE */
        @include mq.screen_sm(min) {
            &__label {
                display: flex;
            }
        }
    }
</style>
